module.exports = __webpack_public_path__ + "img/corner-right-down.26e5eb19.svg";